import { useEffect, useRef, useState } from "react";

export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    // Enable only on devices with fine pointer (desktop)
    const mq = window.matchMedia("(pointer: fine)");
    if (!mq.matches) return;
    setEnabled(true);
    document.documentElement.style.cursor = "none";

    let rx = 0,
      ry = 0,
      mx = 0,
      my = 0;
    let raf;

    const onMove = (e) => {
      mx = e.clientX;
      my = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${mx}px, ${my}px)`;
      }
    };

    const onOver = (e) => {
      const t = e.target;
      if (!ringRef.current) return;
      const isLink =
        t.closest("a, button, [role=button], input, select, textarea, label");
      ringRef.current.dataset.hover = isLink ? "1" : "0";
    };

    const loop = () => {
      rx += (mx - rx) * 0.18;
      ry += (my - ry) * 0.18;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${rx}px, ${ry}px)`;
      }
      raf = requestAnimationFrame(loop);
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("mouseover", onOver, { passive: true });
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      document.documentElement.style.cursor = "";
    };
  }, []);

  if (!enabled) return null;

  return (
    <>
      {/* Outer halo ring */}
      <div
        ref={ringRef}
        aria-hidden="true"
        className="fixed top-0 left-0 pointer-events-none z-[110]"
        style={{
          transform: "translate(-100px, -100px)",
          width: 36,
          height: 36,
          marginLeft: -18,
          marginTop: -18,
          borderRadius: "50%",
          border: "1px solid rgba(212,175,55,0.6)",
          boxShadow: "0 0 20px rgba(232,165,180,0.35)",
          transition:
            "width 0.3s cubic-bezier(.16,1,.3,1), height 0.3s cubic-bezier(.16,1,.3,1), margin 0.3s, background 0.3s",
          mixBlendMode: "normal",
        }}
        data-hover="0"
      />
      {/* Inner dot */}
      <div
        ref={dotRef}
        aria-hidden="true"
        className="fixed top-0 left-0 pointer-events-none z-[111]"
        style={{
          transform: "translate(-100px, -100px)",
          width: 6,
          height: 6,
          marginLeft: -3,
          marginTop: -3,
          borderRadius: "50%",
          background:
            "linear-gradient(135deg, var(--iw-gold), var(--iw-rose))",
          boxShadow: "0 0 10px rgba(212,175,55,0.8)",
        }}
      />
      <style>{`
        [data-hover="1"] {
          width: 56px !important;
          height: 56px !important;
          margin-left: -28px !important;
          margin-top: -28px !important;
          background: rgba(232,165,180,0.12) !important;
          border-color: rgba(232,165,180,0.8) !important;
        }
      `}</style>
    </>
  );
}
